import React from 'react';
import { ReferenceInput, required, SelectInput, minValue } from 'react-admin';
import { Form, Field } from 'react-final-form';
import { CardActions, CardContent, CardHeader, Grid, Divider } from '@material-ui/core';

import { USER } from '@/vars';
import { useAuth } from '@/utils/auth';
import { Button } from '@/components';
import { TextInput } from '@/components/input';
import { NumberInput } from '@/ra';

const EmployeeTypeForm = ({ save, saving, record, redirect, ...rest }) => {
  const { permissions } = useAuth();
  const isAdmin = permissions.role === USER.ROLE.ADMIN;
  const onSubmit = data => save(data, redirect);

  return (
    <Form onSubmit={onSubmit} initialValues={record} keepDirtyOnReinitialize validateOnBlur>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <CardHeader title="Type details" />
          <CardContent style={{ maxWidth: 500 }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextInput label="Employee type" name="name" validate={required('Please enter a employee type.')} />
              </Grid>
              <Grid item xs={12}>
                <NumberInput
                  label="Credit"
                  name="credit"
                  validate={[required('Please enter a credit.'), minValue(0, 'Credit cannot be lower than 0.')]}
                />
              </Grid>
              {isAdmin ? (
                <Grid item xs={12}>
                  <ReferenceInput source="client" reference="clients" filterToQuery={() => {}}>
                    <SelectInput
                      optionText="companyName"
                      variant="outlined"
                      fullWidth
                      margin="none"
                      perPage={99999}
                      validate={required('Please select a client.')}
                    />
                  </ReferenceInput>
                </Grid>
              ) : (
                <Field component="input" type="hidden" name="client" initialValue={permissions.client_id} />
              )}
            </Grid>
          </CardContent>

          <Divider />
          <CardActions>
            <Button type="submit" variant="contained" color="primary" loading={saving}>
              Save
            </Button>
          </CardActions>
        </form>
      )}
    </Form>
  );
};

export default EmployeeTypeForm;
